<script>
   /*********************************************************************/
   /* HotellingEllipse                                                  */
   /* --------------------                                              */
   /* shows Hottelling T2 ellipse on top of the scores plot             */
   /*********************************************************************/

   import { Vector } from 'mdatools/arrays';
   import { Lines } from 'svelte-plots-basic/2d';
   import { qchisq } from 'mdatools/distributions';

   // component parameters
   export let resobj;                              // JSON with PCA result object
   export let comp;                                // selected components
   export let minYVal;                             // smallest value of the statistic
   export let maxYVal;                             // largest value of the statistic
   export let minXVal;                             // smallest value of the statistic
   export let maxXVal;                             // largest value of the statistic
   export let lineColor = '#606060';               // color for the ellipse
   export let lineType = 2;                        // line type for the ellipse
   export let alpha = 0.05;                        // confidence level

   /*****************************************/
   /* Component code                        */
   /*****************************************/

   const angles = Vector.seq(0, 2 * Math.PI, 0.05);

   function getCoordinates(res, comp, fun, angles) {
      const lambda = res.eigenvals[comp - 1];
      const c = qchisq(1 - alpha, 2);
      const a = Math.sqrt(c * lambda);
      const x = Vector.zeros(angles.length);
      for (let i = 0; i < angles.length; i++) {
         x.v[i] = a * fun(angles.v[i]);
      }
      return [x, -a, a];
   }


   // reactive statement to track chenges in "reobj" and "comp[0]" (x-axis)
   let compX = 0, compXVal = null;
   $: if (resobj && comp && comp[0] !== compX) {
      compX = comp[0];
      [compXVal, minXVal, maxXVal] = getCoordinates(resobj, compX, Math.cos, angles);
   }

   // reactive statement to track chenges in "reobj" and "comp[1]" (y-axis)
   let compY = 0, compYVal = null;
   $: if (resobj && comp && comp[1] !== compY) {
      compY = comp[1];
      [compYVal, minYVal, maxYVal] = getCoordinates(resobj, compY, Math.sin, angles);
   }
</script>


<Lines xValues={compXVal} yValues={compYVal} {lineColor} {lineType}/>